var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('horizontal-header')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }